<div class="multi-post-container" [class.notOne]="post.messages.length > 1">
  <mat-card *ngFor="let msg of post.messages" style="margin-bottom: 8px" [class.has-error]="hasError(msg)">
    <tg-post-message-item [msg]="msg"></tg-post-message-item>
  </mat-card>
</div>
